import { useState, useCallback } from 'react';

/**
 * useLocalStorage — Generic persistent state hook backed by localStorage.
 *
 * @param {string} key        - localStorage key
 * @param {*}      initial    - default value if key is not yet stored
 * @returns {[value, setter]} - same API as useState
 */
export function useLocalStorage(key, initial) {
  const [value, setValue] = useState(() => {
    try {
      const stored = localStorage.getItem(key);
      return stored !== null ? JSON.parse(stored) : initial;
    } catch {
      return initial;
    }
  });

  const set = useCallback(
    (next) => {
      const resolved = typeof next === 'function' ? next(value) : next;
      setValue(resolved);
      try {
        localStorage.setItem(key, JSON.stringify(resolved));
      } catch {
        // localStorage unavailable (e.g. private browsing quota)
      }
    },
    [key, value]
  );

  return [value, set];
}
